import 'vue-googlemaps/dist/vue-googlemaps.css'
import VueGoogleMaps from 'vue-googlemaps'
import Vue from "vue"

Vue.use(VueGoogleMaps, {
    load: {
        // Google API key
        apiKey: process.env.VUE_APP_GOOGLE_MAP_API_KEY,
        // Enable more Google Maps libraries here
        libraries: ['places'],
        // Use new renderer
        useBetaRenderer: false,
    },
})